export default __webpack_public_path__ + "static/media/MisPedidos.67cdb825.svg";